import { Inline, Schema } from '@gitbook/slate';

import { INLINE_EMOJI, LEAF_RICH_BLOCKS } from '../types';

/*
 * Schema to validate emojis.
 */
export const schema = Schema.create({
    inlines: {
        [INLINE_EMOJI]: {
            isVoid: true,
            parent: { types: LEAF_RICH_BLOCKS },
            data: {
                code: (code) => typeof code === 'string',
            },
        },
    },
});

/**
 * Create an emoji inline node.
 */
export function createEmoji(code: string): Inline {
    return Inline.createVoid({
        type: INLINE_EMOJI,
        data: {
            code,
        },
    });
}
